import axios from 'axios'
export const addCameraSecurity = async(appKey, appSecret, targetId) => {
  const { data } = await axios.post(`/sensor/oapi/camera-security`, {
    appKey,
    appSecret,
    targetId
  })
  return data
}
/**
 * 查询摄像头的AppKey AppSecret配置
 * @param {*String} targetId 所属项目id
 */
export const getCameraSecurity = async (targetId) => {
  // const { data } = await axios.get(`ezopenConfig/camera-security/info-by-target-id?targetId=${targetId}`)
  const { data } = await axios.get(`/sensor/oapi/camera-security/find-by-target-id/${targetId}`)
  return data
}

/**
 * 更新，保存摄像头的AppKey AppSecret配置
 * @param {*String} appKey 萤石云appkey
 * @param {*String} appSecret 萤石云appSecret
 * @param {*String} targetId 所属项目id
 */
export const setCameraSecurity = async (appKey, appSecret, targetId) => {
  // const { data } = await axios.post(`ezopenConfig/camera-security/save-or-update`, {
  //   appKey,
  //   appSecret,
  //   targetId
  // })
  const { data } = await axios.put(`/sensor/oapi/camera-security`, {
    appKey,
    appSecret,
    id: targetId
  })
  return data
}

/**
 * 更新，保存摄像头，序列号，验证码数据
 * @param {*Array} list 摄像头数组数据{verifyCode, serialNumber}，每次请求，将当前的摄像头设备数据全部都回传回来，做更新保存
 * @param {*String} targetId 所属设备id
 */
export const setCameraBind = async (list, targetId) => {
  // const { data } = await axios.post(`ezopenConfig/camera/save-or-update`, {
  //   list,
  //   targetId
  // })
  const { data } = await axios.post(`/sensor/oapi/component-camera/save-or-update`, {
    cameraReqList: list,
    targetId
  })
  return data
}

/**
 * 根据目标id查询摄像头数据
 * @param {*String} targetId 所属设备id
 */
export const getCameraBind = async (targetId) => {
  // const { data } = await axios.get(`ezopenConfig/camera/info-by-code?targetId=${targetId}`)
  const { data } = await axios.get(`/sensor/oapi/component-camera/find-by-target-id/${targetId}`)
  return data
}

/**
 * 获取萤石云摄像头token
 * @param {*String} targetId 所属项目id
 */
export const getCameraToken = async (targetId) => {
  // const { data } = await axios.get(`ezopenConfig/camera-security/token-by-target-id?targetId=${targetId}`)
  const { data } = await axios.get(`/sensor/oapi/camera-security/get-token-by-target-id/${targetId}`)

  return data
}
